export default "__VITE_PUBLIC_ASSET__775d81d0__"